export const NavigationConfig = {
    Account: {
        Signup: "/signup",
        Login: "/login",
        Forgot_Password: "/forgotpassword",
        Reset_Password: "/resetpassword",
        Email_Confirmation: "/emailconfirmation",
        Verify_Success: "/verifysuccess",
        Landing: "/dashboard",
        NeedHelp: "/needhelp",
        SignUP_OTP: "/signup_otp",
        Forgot_Pwd_OTP: "/forgot_pwd_otp",
    },
    Dashboard: "/dashboard",
    AnalyticsDashboard: "/analyticsDashboard",
    CreateApplication: "/createApplication",
    UpdateApplication: "/updateApplication",
    QuoteTool: "/quoteTool",
    DeepLinkMail: "/deepLinkMail",
    SendApplicationLink: "/sendApplicationLink",
    LineOfCredit: "/lineOfCredit",
    DealerOperatedRentalFleet: "/dealerOperatedRentalFleet",
    UpdateDealerOperatedRentalFleet: "/updateDealerOperatedRentalFleet",
    UpdateLineOfCredit: "/updateLineOfCredit",
    LocDetailsByTaxId: "/locDetailsByTaxId",
    ScheduleTakedownApplication: "/ScheduleTakedownApplication",
    PageNotFound: "/*",
    AdminDashboard: "/adminDashboard",
    CreateApplicationDeeplink: "/createApplicationDeeplink",
    LineOfCreditDeeplink: "/lineOfCreditDeeplink",
    ScheduleTakedownApplicationDeeplink: "/scheduleTakedownApplicationDeeplink",
    DeeplinkPreAndPostSubmission: "/deeplinkSubmission",
    QuoteHistory: "/quotehistory",
    Applications: "/applications",
    RateCard: "/ratecard",
    QuotePreview: "/quotePreview",
};
